import React, { memo } from 'react';
import moment from 'moment';
import { has } from 'lodash';
import styled from 'styled-components/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

import Select from 'components/ui/Select';

const StartDateField = styled.div`
  .MuiFormControl-root {
    margin-bottom: 0;
  }

  .MuiTypography-root {
    font-size: 0.75em;
  }
`;

const Spacer = styled.div``;

const bookingCutOffOptions = [
  { label: 0, value: 0 },
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
];

const Time = memo(
  ({
    setFieldValue,
    touched,
    errors,
    handleChange,
    startDate,
    startTime,
    endDate,
    endTime,
    multiDays,
    bookingCutOffDaysNum,
    initValues,
    setSelectedStaff,
    setStaffList,
  }) => {
    const handleCheck = (e) => {
      setFieldValue('multiDays', e.target.checked ? 1 : 0);
    };

    const handleOnBlur = (value, compareField) => {
      // Unselect all staff if start/end date and time have changed

      if (value !== initValues[compareField]) {
        setSelectedStaff([]);
        setStaffList((prevState) =>
          prevState.map((staff) => ({
            ...staff,
            selected: 'unselected',
          })),
        );
      }
    };

    return (
      <>
        <StartDateField>
          <KeyboardDatePicker
            format="MM/dd/yyyy"
            disableToolbar
            variant="inline"
            fullWidth
            label="Start Date"
            name="startDate"
            onChange={(value) => setFieldValue('startDate', value)}
            required
            value={startDate}
            KeyboardButtonProps={{ 'aria-label': 'change date' }}
            inputVariant="outlined"
            error={touched.startDate && has(errors, 'startDate')}
            helperText={touched.startDate && errors.startDate}
            onBlur={(e) =>
              handleOnBlur(
                moment(e.target.value).format('YYYY/MM/DD'),
                'startDate',
              )
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={multiDays}
                onChange={handleCheck}
                name="multiDays"
              />
            }
            label="Multi-day"
          />
        </StartDateField>

        {multiDays === 1 ? (
          <KeyboardDatePicker
            format="MM/dd/yyyy"
            disableToolbar
            variant="inline"
            fullWidth
            label="End Date"
            name="endDate"
            onChange={(value) => setFieldValue('endDate', value)}
            required
            value={endDate}
            KeyboardButtonProps={{ 'aria-label': 'change date' }}
            error={touched.endDate && has(errors, 'endDate')}
            inputVariant="outlined"
            helperText={touched.endDate && errors.endDate}
            onBlur={(e) =>
              handleOnBlur(
                moment(e.target.value).format('YYYY/MM/DD'),
                'endDate',
              )
            }
          />
        ) : (
          <Spacer />
        )}

        <TextField
          id="time"
          label="Start Time"
          type="time"
          variant="outlined"
          value={startTime}
          name="startTime"
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            step: 15 * 60, // 15 min
          }}
          required
          onBlur={(e) => handleOnBlur(e.target.value, 'startTime')}
        />

        <TextField
          id="time"
          label="End Time"
          type="time"
          variant="outlined"
          value={endTime}
          name="endTime"
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            step: 15 * 60, // 15 min
          }}
          required
          onBlur={(e) => handleOnBlur(e.target.value, 'endTime')}
        />

        <Select
          options={bookingCutOffOptions}
          label="Booking Cut Off"
          variant="outlined"
          errors={
            touched.bookingCutOffDaysNum && has(errors, 'bookingCutOffDaysNum')
          }
          touched={touched}
          helperText={
            touched.bookingCutOffDaysNum && errors.bookingCutOffDaysNum
          }
          name="bookingCutOffDaysNum"
          onChange={handleChange}
          value={bookingCutOffDaysNum}
          disableNone
          required
        />
      </>
    );
  },
);

export default Time;
